import { Component, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { GeneralService } from 'src/app/core/services/general/general.service';
import { Carrera } from 'src/app/shared/models/observacion';

@Component({
  selector: 'app-buscador-posgrados',
  templateUrl: './buscador-posgrados.component.html',
  styleUrls: ['./buscador-posgrados.component.scss']
})
export class BuscadorPosgradosComponent implements OnInit {
  @Input() sede;
  @Input() data: any
  @Input() padding;
  @Input() paddingMob;
  @Input() translateY;
  meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
  nivelPrioridad = ['Doctorado', 'Maestría', 'Especialización', 'Curso de Posgrado'];
  regiones: any[] = [];
  carreras: Carrera[] = [];
  niveles: Carrera[] = [];
  areas: Carrera[] = [];
  facultades: Carrera[] = [];
  modalidades: Carrera[] = [];
  resultados: Carrera[] = [];
  buscador: UntypedFormGroup;
  valor: string;
  count: number;
  pages: number[] = [];
  numberActive: number = 1;
  pageSize = 15;
  spinner = true;
  filtro = false;
  language = "es";
  destacadas = true;
  isContentVisible = false;
  mostrarContenido = false;
  @Input() detallePosgrado: boolean = false
  @ViewChild('swipeContainer') swipeContainer2!: ElementRef;
  @ViewChild('busqueda') busqueda!: ElementRef;
  @ViewChild('resultadosSwipe') resultadosSwipe: ElementRef;
  @ViewChild('filtroInput') filtroInput!: ElementRef;

  isDesktop: boolean;
  @ViewChild('spinnerContainer') spinnerContainer: ElementRef;
  minHeightRestante: number = 0;

  constructor(public route: ActivatedRoute, private servicesGeneral: GeneralService, private form: UntypedFormBuilder, private renderer: Renderer2, private el: ElementRef) {
    this.route.params.forEach((params: Params) => {
      this.language = (params['language']) ? params['language'] : 'es';
    });
    this.buscador = this.form.group({
      sede: ['',],
      area: ['',],
      nivel: ['',],
      modalidad: ['',],
      facultad: ['',],
      palabras: ['',],
    });
    this.servicesGeneral.getPosgrados(null, null, null, null, null, null, null, this.destacadas).subscribe(data => {
      this.areas = data.data[0].area;
      this.facultades = data.data[0].facultades;
      this.regiones = data.data[0].region;
      this.modalidades = data.data[0].modalidad;
      this.niveles = data.data[0].careerType;
      this.regiones = data.data[0].region;
      if (this.sede) this.buscador.controls['sede'].setValue(this.sede?.id)

      this.filtrar(false);

    })
  }



  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkDeviceType()
    this.calcularAlturaRestante();
  }



  ngAfterViewInit(): void {
    setTimeout(() => {
      this.filtroInput.nativeElement.focus({ preventScroll: true });
    }, 100);
    this.calcularAlturaRestante();
  }
  ngOnInit(): void {
    this.checkDeviceType();
    this.spaceBetweenElements();
    setTimeout(() => {
      this.isContentVisible = true;
    }, 3000);
  }
  calcularAlturaRestante() {
    if (this.spinnerContainer) {
      const rect = this.spinnerContainer.nativeElement.getBoundingClientRect();
      this.minHeightRestante = window.innerHeight - rect.top;
    }
  }

  redirect(c) {
    window.location.href = this.language + c.linkCareer
  }

  getMarginTop(height: any) {
    let marginTopResultados = '0px'
    if (this.translateY.includes("%")) {
      let porcentaje = parseFloat(this.translateY) / 100;
      marginTopResultados = (height * porcentaje) - 10 + "px";
    }
    return marginTopResultados;
  }

  checkDeviceType() {
    this.isDesktop = window.innerWidth >= 768;
    if (!this.isDesktop) {
      this.pageSize = 10
    }
    let height = $(".buscador-container").outerHeight();
    $(".resultados").css("margin-top", "-" + this.getMarginTop(height));

    if (this.isDesktop) {
      $(".buscador-container").css("padding", this.padding);
      $(".buscador-container").css("transform", "translateY(-" + this.translateY + ")");
      $(".resultados").css("padding-bottom", (this.resultados.length == 0) ? "5px" : "-90px");
    } else {
      $(".buscador-container").css("padding", this.paddingMob + "px");
      $(".buscador-container").css("transform", "translateY(-" + 0 + "px)");
      $(".resultados").css("margin-top", (this.resultados.length == 0) ? "0px" : "20px");
      $(".resultados").css("padding-bottom", (this.resultados.length == 0) ? "0px" : "-90px");

    }
    this.spaceBetweenElements();


  }
  private posgradosSub: Subscription;

  filtrar(event) {
    $(".resultados-principal").css("margin-top", "-90px");
    this.spinner = true;
    this.filtro = true;

    const sede = this.buscador.get('sede').value;
    const nivel = this.buscador.get('nivel').value;
    const area = this.buscador.get('area').value;
    const palabras = this.buscador.get('palabras').value;
    const modalidad = this.buscador.get('modalidad').value;
    const facultad = this.buscador.get('facultad').value;

    let first = false;
    this.destacadas = sede == '' && nivel == '' && area == '' && palabras == '' && modalidad == '' && facultad == '';
    let scrollear = !(palabras && sede == '' && nivel == '' && area == '' && modalidad == '' || this.sede != '');

    if (this.posgradosSub) {
      this.posgradosSub.unsubscribe();
    }

    this.posgradosSub = this.servicesGeneral
      .getPosgrados(sede, nivel, area, palabras, facultad, modalidad, facultad, this.destacadas)
      .subscribe({
        next: (data) => {
          let aux = [];
          this.resultados = [];
          this.carreras = [];

          if (event) {
            this.areas = data.data[0].area;
            this.facultades = data.data[0].facultades;
            this.regiones = data.data[0].region;
            this.modalidades = data.data[0].modalidad;
            this.niveles = data.data[0].careerType;
            first = true;
          }

          if (data.data[0].career) {
            data.data[0].career.sort((a, b) => {
              return this.nivelPrioridad.indexOf(a.nivel) - this.nivelPrioridad.indexOf(b.nivel);
            });

            data.data[0].career.forEach(element => {
              element.title = this.cortarTitulo(element.title);
              aux.push(element);
            });

            this.carreras = aux.sort((a, b) =>
              (a.fecha && b.fecha) ? a.fecha.getTime() - b.fecha.getTime() : 0
            );
          }

          this.cambiarPagina(1, first, scrollear);
          this.spinner = false;
        },
        error: (err) => {
          console.error('Error en getPosgrados:', err);
          this.spinner = false;
        }
      });
  }

  updateFilter(field: string, value: any) {
    this.buscador.get(field).setValue(value);
    this.filtrar(null);
  }

  spaceBetweenElements() {

    if (this.carreras.length == 0) {
      $(".fondo-area").css("margin-top", "0px");
      $(".fondo-area").css("padding-top", "0px");
      $(".resultados-principal").css("margin-top", "-140px");
      $(".resultados ul").css("padding", "0px!important");

    } else {
      let altura = $('.buscador-container').outerHeight();
      $(".fondo-area").css("margin-top", "-160px");
      $(".fondo-area").css("padding-top", "180px");
      $(".resultados ul").css("padding", "14px 0px 0px 0px");

    }
  }

  cambiarPagina(page, first, scrollear) {

    this.pages = [];
    //  let resultadoFiltrado = this.filtros(modalidad);
    this.resultados = this.carreras.slice(((page - 1) * this.pageSize), (page) * this.pageSize)
    let cant = Math.ceil(this.carreras.length / this.pageSize)
    for (let i = 0; i < cant; i++) {
      this.pages.push(i + 1);
    }
    this.checkDeviceType();
    this.spaceBetweenElements();

    this.numberActive = page;
    page = (page == '...') ? (this.numberActive) : page;
    this.spinner = false;
    if (!first && scrollear || !this.isDesktop && scrollear && !first) {
      //this.busqueda.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (this.resultadosSwipe) {
        const resultadosElement = this.resultadosSwipe.nativeElement;
        const yOffset = -100
        const y = resultadosElement.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  }

  primerPaginaHabilitada(): boolean {
    return this.numberActive > 1;
  }

  ultimaPaginaHabilitada(): boolean {
    return this.numberActive < this.pages.length;
  }

  get rangoResultados(): string {
    const startIndex = (this.numberActive - 1) * this.pageSize + 1;
    const endIndex = Math.min(startIndex + this.pageSize - 1, this.carreras.length);
    return `${startIndex}-${endIndex} de ${this.carreras.length}`;
  }
  getInicio(mes: number, año: number) {
    return this.meses[mes] + ' ' + año;
  }
  processText(palabra: string): string {
    palabra = palabra.trim();
    palabra = palabra.toLocaleLowerCase();

    return palabra;
  }
  formatearFecha(value: any): any {
    if (value) {
      const date = new Date(value);
      const monthNames = [
        "enero", "febrero", "marzo",
        "abril", "mayo", "junio", "julio",
        "agosto", "septiembre", "octubre",
        "noviembre", "diciembre"
      ];

      const day = date.getDate();
      const monthIndex = date.getMonth();
      const monthName = monthNames[monthIndex];

      return `${day} de ${monthName}`;
    } else {
      return 'CONSULTAR'
    }

  }
  ngOnDestroy() {

  }
  cortarTitulo(titulo) {
    if (titulo.length > 50) {
      return titulo.slice(0, 50) + "...";
    } else {
      return titulo;
    }
  }
}


